export default "__VITE_ASSET__DJiKFush__"